"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePageTabPane = exports.PAGE_TAB_PANE_CHANGE = void 0;

var _getActionName = require("../../skybase-core/utils/get-action-name");

var _createAction = require("../../skybase-core/base/create-action");

var _constants = require("../../constants");

/**
 * @desc
 * Action for changing the page tab pane.
 */
var PAGE_TAB_PANE_CHANGE = (0, _getActionName.getActionName)('PAGE_TAB_PANE_CHANGE', _constants.MODULE_NAME);
exports.PAGE_TAB_PANE_CHANGE = PAGE_TAB_PANE_CHANGE;

var changePageTabPane = function changePageTabPane(pageId, tabId) {
  return (0, _createAction.createAction)(PAGE_TAB_PANE_CHANGE, {
    pageId: pageId,
    tabId: tabId
  });
};

exports.changePageTabPane = changePageTabPane;
//# sourceMappingURL=page-tab-pane-actions.js.map